import React from 'react';
import { useCart } from '../context/CartContext';
export function GenericCollection({
  title,
  description,
  images = []
}: {
  title: string;
  description: string;
  images?: string[];
}) {
  const {
    addToCart
  } = useCart();
  const displayImages = images.length > 0 ? images : [null, null, null];
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-554">
      <div className="max-w-[1800px] mx-auto" data-id="element-555">
        <header className="mb-20 text-center" data-id="element-556">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-4 block text-black/40" data-id="element-557">
            Collection
          </span>
          <h1 className="text-xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-558">
            {title}
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-559">
            {description}
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-560">
          {displayImages.map((img, i) => <div key={i} className="group" data-id="element-561">
              <div className="aspect-[3/4] bg-grey-divider overflow-hidden mb-4 relative" data-id="element-562">
                {img ? <>
                    <img src={img} alt={`${title} Piece ${i + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-563" />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-564">
                      <button onClick={() => addToCart({
                  id: `${title}-${i}`,
                  name: `${title} Piece ${String(i + 1).padStart(2, '0')}`,
                  price: '$240.00',
                  image: img,
                  quantity: 1,
                  size: 'OS'
                })} className="bg-white text-black px-6 py-3 text-xs font-display font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-565">
                        Add to Bag
                      </button>
                    </div>
                  </> : <div className="w-full h-full bg-black/5 group-hover:bg-black/10 transition-colors" data-id="element-566" />}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors" data-id="element-567" />
              </div>
              <div className="flex justify-between items-start" data-id="element-568">
                <div data-id="element-569">
                  <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase mb-1" data-id="element-570">
                    {title} Piece {String(i + 1).padStart(2, '0')}
                  </h3>
                  <p className="text-sm font-light text-black/50" data-id="element-571">$240.00</p>
                </div>
                <button onClick={() => addToCart({
              id: `${title}-${i}`,
              name: `${title} Piece ${String(i + 1).padStart(2, '0')}`,
              price: '$240.00',
              image: img || '',
              quantity: 1,
              size: 'OS'
            })} className="md:hidden text-xs font-display font-bold uppercase tracking-widest border-b border-black pb-0.5" data-id="element-572">
                  Add to Bag
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}